import React from "react";
import axios from "axios";
import { VERIFY_TOKEN_API } from "../../../Constants/Apis";
import { doSignIn, getToken } from "../../../Utils/CommonUtils";
import { Button, Form, Input, message } from "antd";
import "./LoginPage.css";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
    };
  }

  async componentDidMount() {
    const { history } = this.props;
    await this.authenticateToken(history);
  }

  authenticateToken = async (history) => {
    try {
      const token = getToken();

      if (!token) {
        return this.setState({ authenticated: false });
      }

      const response = await axios.get(`${VERIFY_TOKEN_API}/${token}`);

      const dateIsExpired = Date.now() >= response.data.decodedToken.exp * 1000;
      const verifyFail = response.status !== 200;

      if (verifyFail || dateIsExpired) {
        localStorage.removeItem("token"); // Instead of clearing everything
        return this.setState({ authenticated: false });
      }

      this.setState({ authenticated: true }, () => {
        history.push("/user/welcome");
      });
    } catch (e) {
      console.error("Error verifying token:", e);
      localStorage.removeItem("token");
      this.setState({ authenticated: false });
    }
  };

  onFinish = async (values) => {
    const { history } = this.props;

    try {
      const response = await doSignIn({
        ...values,
        appType: "web" // Added appType parameter
      }, history);

      const accessToken = response?.data?.accessToken;

      if (!accessToken) {
        return message.error("Login Failed. No token received.");
      }

      window.localStorage.setItem("token", accessToken);

      this.setState({ authenticated: true }, () => {
        history.push("/user/welcome");
      });
    } catch (error) {
      console.error("Login Error:", error);
      if (error?.response?.status === 401) {
        return message.error("Password Did Not Match");
      }
      if (error?.response?.status === 403) {
        return message.error("Access denied for web app");
      }
      return message.error("Something Went Wrong. Login Failed.");
    }
  };

  onFinishFailed(errorInfo) {
    return message.error(errorInfo?.errorFields[0]?.errors);
  }

  render() {
    return (
      <div className="container justify-items-center grid">
        <h1
          className="text-4xl text-white mt-10"
          style={{ textAlign: "center" }}
        >
          Sign In
        </h1>
        <div className="sign-in-form border w-full sm:w-1/4 mt-6 grid justify-items-center p-10 bg-white rounded-xl">
          <Form
            name="basic"
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 5 }}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Username"
              name="username"
              rules={[
                { required: true, message: "Please input your username!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 10, span: 3 }}>
              <Button type="primary" htmlType="submit" className="bg-green-600">
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

export default LoginPage;
